import React from 'react';
import Loader from '../../components/common/Loader';
import Footer from '../../components/common/Footer';
import Menu from '../../components/common/Menu';
import Navbar from '../../components/common/Navbar';
import StartButton from '../../components/home/StartButton';
import FloatingCheckoutButton from '../../components/common/FloatingCheckoutButton';
import Header from '../../components/innerpage/about/Header';
import Description from '../../components/innerpage/about/Description';
import {Helmet} from 'react-helmet';
import { usePageLoader } from '../../hooks/usePageLoader';

const AboutPage: React.FC = () => {
    usePageLoader(); // Hide loader on mount for client-side navigation

    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://tempefab.com/about"/>
                <title>About Us | Tempe Fabrication | Custom Metal Fabrication</title>
                <meta name="description"
                      content="Learn about Tempe Fabrication's expertise in custom metal fabrication, architectural metalwork, and precision craftsmanship in Tempe, Arizona."/>
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="/home/assets/css/home_1_style.css"
                />
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="/innerpages/assets/css/innerpages.css"
                />
                <script src="/common/assets/js/common_js.js"></script>
                <script src="/innerpages/assets/js/innerpages.js"></script>
            </Helmet>
            <div className="inner-pages-style1 about-pg-style1">
            <Loader/>
            <Menu/>
            <div className="smooth-scroll-content" id="scrollsmoother-container">
                <Navbar currentPage="about"/>
                <Header/>

                <main>
                    <Description />
                </main>
                <Footer/>
            </div>
            <StartButton/>
            <FloatingCheckoutButton/>
            </div>
        </>
    );
}

export default AboutPage;